<template>
  <DogGenerator />
</template>

<script>
import DogGenerator from './views/DogGenerator.vue'

export default {
  components: { DogGenerator },
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
